import RiskAssesmentCardItem from "../../molecules/riskassesmentcard/RiskAssesmentCardItem";
import Accordion from "react-bootstrap/Accordion";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useMediaQuery } from "react-responsive";
import StbButton from "../../atoms/button/StbButton";
import type { RiskAssesmentContainerDto as RiskAssesmentContainer } from '../../../api/generated/model/riskAssesmentContainerDto';
import type { RiskAssesmentItemDto as RiskAssesmentItem } from '../../../api/generated/model/riskAssesmentItemDto';
import "./RiskAssesmentContainer.css";

interface RiskAssesmentContainerProp {
  riskAssesmentContainer?: RiskAssesmentContainer,
  onUpdate: (updatedData: RiskAssesmentContainer) => void,
  isWorkerView: boolean
}

const STANDARD_RISK_NAMES = new Set([
  'Bullrig arbetsmiljö',
  'Dammig arbetsmiljö',
  'Ensamarbete',
  'Felaktiga arbetsställningar',
  'Halkrisk',
  'Hantering av farliga ämnen',
  'Risk för fallande material',
  'Allmänna risker i närområdet',
  'Risk för fall',
  'Fall bidrar till svårt belägen hängandes person',
  'Risk för ras',
  'Skärskador',
  'Tunga lyft',
  'Vibrerande maskiner',
  'Risk för tredje man',
  'Begränsade kommunikationsmöjligheter',
  'Begränsad framkomlighet för räddningsfordon',
]);

const withoutOtherRisk = (items: RiskAssesmentItem[]): RiskAssesmentItem[] =>
  items.filter((item) => item.name?.trim().toLocaleLowerCase('sv-SE') !== 'övrigt');

const EMPTY_RISKS: RiskAssesmentItem[] = [];

const RiskAssesmentContainerItem: React.FC<RiskAssesmentContainerProp> = (props) => {
  const riskAssesmentContainer = props.riskAssesmentContainer;
  const isScreenSmall = useMediaQuery({ maxWidth: 1026 });
  const items = withoutOtherRisk(riskAssesmentContainer?.riskAssesmentItems ?? EMPTY_RISKS);

  const handleItemUpdate = (index: number, updatedItem: RiskAssesmentItem) => {
    const updatedItems = [...items];
    updatedItems[index] = updatedItem;
    publishItems(updatedItems);
  };

  const publishItems = (updatedItems: RiskAssesmentItem[]) => {
    if (riskAssesmentContainer) {
      props.onUpdate({
        ...riskAssesmentContainer,
        riskAssesmentItems: updatedItems,
      });
    }
  };

  const addRisk = () => {
    publishItems([
      ...items,
      {
        name: '',
        noExtent: null,
        smallExtent: null,
        highExtent: null,
        personalSafetyEquipment: '',
        riskForIllnes: '',
        containerId: riskAssesmentContainer?.id,
      },
    ]);
  };

  const removeRisk = (index: number) => {
    publishItems(items.filter((_, itemIndex) => itemIndex !== index));
  };

  return (
    <div className="">
      <Row className="titleRow ">
        {isScreenSmall && (
          <Col xs={8} sm={6} md={5} lg={4} xl={3} className="alignLeft">Arbetsmiljörisk</Col>
        )}
        {!isScreenSmall && (
          <>
            <Col xs={8} sm={6} md={5} lg={4} xl={3} className="alignLeft">
              <span className="titleCellLabel">Arbetsmiljörisk</span>
            </Col>
            <Col xs={6} sm={4} md={3} lg={2} xl={1} className="titleCellCompact">
              <span className="titleCellLabel">Inte alls</span>
            </Col>
            <Col xs={6} sm={4} md={3} lg={2} xl={1} className="titleCellCompact">
              <span className="titleCellLabel">I liten omfattning</span>
            </Col>
            <Col xs={6} sm={4} md={3} lg={2} xl={1} className="titleCellCompact">
              <span className="titleCellLabel">I hög omfattning</span>
            </Col>
            <Col xs={8} sm={6} md={5} lg={4} xl={3}>
              <span className="titleCellLabel">Personlig skyddsutrustning som används</span>
            </Col>
            <Col xs={8} sm={6} md={5} lg={4} xl={3}>
              <span className="titleCellLabel">Vilka åtgärder behöver vidtas för att minska eller eliminera risk för ohälsa</span>
            </Col>
          </>
        )}
      </Row>
      <div className="borderBottom"></div>
      {items.map((item, index) => (
        isScreenSmall ? (
          <Accordion key={index}>
            <Accordion.Item eventKey={index.toString()} key={index} className="m-3 shadow">
              <Accordion.Header>{item.name}</Accordion.Header>
              <Accordion.Body>
                <RiskAssesmentCardItem
                  key={index}
                  riskAssesmentItem={item}
                  radioGroupIndex={index}
                  onUpdate={(updatedItem) => handleItemUpdate(index, updatedItem)}
                  isWorkerView={props.isWorkerView}
                  canEditName={!STANDARD_RISK_NAMES.has(item.name ?? '')}
                  onRemove={!props.isWorkerView && !STANDARD_RISK_NAMES.has(item.name ?? '') ? () => removeRisk(index) : undefined}
                />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ) : (
          <RiskAssesmentCardItem
            key={index}
            riskAssesmentItem={item}
            radioGroupIndex={index}
            onUpdate={(updatedItem) => handleItemUpdate(index, updatedItem)}
            isWorkerView={props.isWorkerView}
            canEditName={!STANDARD_RISK_NAMES.has(item.name ?? '')}
            onRemove={!props.isWorkerView && !STANDARD_RISK_NAMES.has(item.name ?? '') ? () => removeRisk(index) : undefined}
          />
        )
      ))}
      <div className="stb-action-bar">
        <StbButton type="button" variant="outline" onClick={addRisk}>
          Lägg till risk
        </StbButton>
      </div>
    </div>
  )
}

export default RiskAssesmentContainerItem;
